// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_RZ0","cls2":"ButtonsPage-cls2_opE ButtonsPage-cls1_RZ0"};